import lodash from 'lodash'
import moment from 'moment'
import React, { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'

import Checkbox from '../../../../../../1stlog-ui/src/components/Checkbox'
import Field, {
  FieldPrefix,
  Label,
  useField,
} from '../../../../../../1stlog-ui/src/components/Field'
import TimePicker from '../../../../../../1stlog-ui/src/components/TimePicker/TimePickerIso'
import useProvider from '../useProvider'

const Wrapper = styled.div`
  align-self: center;
`

const ManualDisposition = (props) => {
  const {} = props

  const provider = useProvider()

  const { allowManualDisposition } = provider || {}

  const [isManualDisposition, setIsManualDisposition] = useField(
    'isManualDisposition',
    {
      asState: true,
    },
  )

  const [start, setStart] = useField('timeWindow.start', { asState: true })
  const [end, setEnd] = useField('timeWindow.end', { asState: true })

  // disable if not available anymore
  useEffect(() => {
    if (!allowManualDisposition) {
      setIsManualDisposition(false)
    } else {
      setIsManualDisposition(true)
    }
  }, [allowManualDisposition])

  useEffect(() => {
    if (lodash.isEmpty(start)) {
      setStart(moment().set('hour', 8).set('minute', 0).toISOString())
    }
  }, [start])

  useEffect(() => {
    if (lodash.isEmpty(end)) {
      setEnd(moment().set('hour', 17).set('minute', 0).toISOString())
    }
  }, [end])

  if (!allowManualDisposition) {
    return null
  }

  return (
    <Wrapper className="mt-1 mb-n1">
      <Field name="isManualDisposition">
        <Checkbox>{i18n.t(`dispose_manually`, `Manuell disponieren`)}</Checkbox>
      </Field>
      {isManualDisposition && (
        <div>
          <div className="mb-1">
            <FieldPrefix name="timeWindow">
              <div>
                <Label>{i18n.t(`timerange`, `Zeitraum`)}</Label>
              </div>
              <div className="d-flex align-items-center">
                <Field name="start">
                  <TimePicker />
                </Field>
                <div className="mx-2" style={{ marginBottom: '5px' }}>
                  {i18n.t(`to`, `bis`)}
                </div>
                <Field name="end">
                  <TimePicker />
                </Field>
              </div>
            </FieldPrefix>
          </div>
          <div className="text-muted">
            <strong>{i18n.t(`note`, `Hinweis`)}:</strong> {i18n.t(`shipment_must_be_disposed_manually`, `Diese Sendung muss nach der Erfassung
            manuell in DisGO disponiert werden.`)}
          </div>
        </div>
      )}
    </Wrapper>
  )
}

export default ManualDisposition
